export enum TIconSize {
  XXX_SMALL = 'xxx-small',
  XX_SMALL = 'xx-small',
  X_SMALL = 'x-small',
  SMALL = 'small',
  MEDIUM = 'medium',
  BIG = 'big',
}
